class SwiperCarousel extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            swiperContainer: ".swiper",
            loop: "data-loop",
            grabCursor: "data-grab-cursor",
            centeredSlides: "data-centered-slides",
            desktopSlidesPerView: "data-slides-per-view",
            mobileSlidesPerView: "data-slides-per-view-mobile",
        };
        this.handleVideoEnded = this.handleVideoEnded.bind(this);
    }

    connectedCallback() {
        const loop = this.hasAttribute(this.selectors.loop);
        const grabCursor = this.hasAttribute(this.selectors.grabCursor);
        const centeredSlides = this.hasAttribute(this.selectors.centeredSlides);
        const desktopSlidesPerView = this.getAttribute(this.selectors.desktopSlidesPerView) ?? 2;
        const mobileSlidesPerView = this.getAttribute(this.selectors.mobileSlidesPerView) ?? 1.25;

        const swiperContainer = this.querySelector(this.selectors.swiperContainer);

        const swiperConfig = {
            speed: 300,
            loop: loop,
            effect: 'coverflow',
            grabCursor: grabCursor,
            centeredSlides: centeredSlides,
            slidesPerView: mobileSlidesPerView,
            coverflowEffect: {
                rotate: 0,
                stretch: 80,
                depth: 250,
                modifier: 1,
                slideShadows: false,
            },
            breakpoints: {
                540: {
                    slidesPerView: desktopSlidesPerView,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };

        this.swiper = new Swiper(swiperContainer, swiperConfig);

        // Add event listener for slide change
        this.swiper.on('slideChange', () => {
            this.handleSlideChange();
        });

        // Play the video in the initial active slide
        this.handleSlideChange();
    }

    handleSlideChange() {
        const slides = this.querySelectorAll('.swiper-slide');
        slides.forEach((slide, index) => {
            const video = slide.querySelector('video');
            
            // Manage opacity based on slide position
            const isAdjacentOrActive = Math.abs(index - this.swiper.activeIndex) <= 1;
            slide.style.opacity = isAdjacentOrActive ? '1' : '0';
            slide.style.transition = 'opacity 0.5s ease-in-out';
            
            if (video) {
                video.controls = false;
                if (index === this.swiper.activeIndex) {
                    // Remove 'ended' event listener from the previous video
                    video.removeEventListener('ended', this.handleVideoEnded);
                    // Add 'ended' event listener to the current video
                    video.addEventListener('ended', this.handleVideoEnded);
                    video.play();
                } else {
                    video.pause();
                    video.currentTime = 0; // Reset video to the beginning
                }
            }
        });
    }

    handleVideoEnded() {
        // Advance to the next slide when the video ends
        this.swiper.slideNext();
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy();
            this.swiper = null;
        }
    }
}

customElements.define('swiper-carousel', SwiperCarousel);
